import { ComponentPropsWithoutRef } from 'react';

interface InfoBannerProps extends ComponentPropsWithoutRef<'div'> {
    variant?: 'default' | 'alert';
    children: React.ReactNode;
}

/**
 * InfoBanner component with styling for different variants.
 *
 * @param variant - Default or alert styling.
 * @param children - Alert contents.
 * @param rest - Other props passed.
 */
export function InfoBanner({
    variant = 'default',
    children,
    ...rest
}: InfoBannerProps) {
    let baseClasses =
        'inline-flex gap-4 items-center justify-center rounded-lg text-lg px-4 py-3 translate-colors border';
    baseClasses = baseClasses + ' ' + rest.className;
    const variantClasses = {
        default: 'bg-grey-300 text-grey-900 border-transparent',
        alert: 'bg-secondary-red-extralight text-secondary-red border-secondary-red',
    };

    const infoBannerClasses = `${baseClasses} ${variantClasses[variant]}`;

    return (
        <div {...rest} className={infoBannerClasses}>
            {children}
        </div>
    );
}
